module.exports = __webpack_public_path__ + "img/1.0f79c5c2.png";